import {Component} from '@angular/core';

import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {ITEM_SAVED_EVENT} from '@common/const/navigation.constants';
import {LanguageService} from '@core/service/language.service';
import {NgbActiveModal, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {finalize} from 'rxjs/operators';
import {HasAnyAccessDirective} from '../../directives/has-any-access.directive';
import {TmwArabicInputComponent} from '../arabic-input/arabic-input.component';

@Component({
  standalone: true,
  selector: 'translation-dialog',
  templateUrl: './translation-dialog.component.html',
  imports: [CommonModule, FormsModule, NgbModule, HasAnyAccessDirective, TmwArabicInputComponent],
})
export class TranslationDialogComponent {
  translation: any;
  isSaving = false;
  lang = '';

  constructor(
    private languageService: LanguageService,
    private activeModal: NgbActiveModal,
  ) {}

  ngOnInit() {
    this.languageService.getCurrent().subscribe((lang: string) => {
      this.lang = lang;
    });
    if (this.translation?.code) {
      this.languageService.find(this.translation.code).subscribe((translationResp: any) => {
        if (translationResp?.code) {
          this.translation = translationResp;
        }
      });
    }
  }

  save() {
    this.isSaving = true;
    this.languageService
      .save(this.translation)
      .pipe(finalize(() => (this.isSaving = false)))
      .subscribe(() => {
        this.activeModal.close(ITEM_SAVED_EVENT);
      });
  }

  cancel() {
    this.activeModal.dismiss();
  }
}
